import { useQuery } from "react-query";

import { dataCleanseService } from "services";

export type useUnknownMidListQueryProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
	isRefreshDataCleanse: boolean;
};

const useUnknownMidListQuery = ({
	fetchData,
	isRefreshDataCleanse,
	paidMonth,
	paidYear,
}: useUnknownMidListQueryProps) => {
	const { page, filters, sortBy } = fetchData;

	const fetchUnknownMidList = () =>
		dataCleanseService.getDataCleanseLists({
			paidMonth,
			paidYear,
			isMerchantMissing: true,
			page,
			filters,
			sortBy,
		});

	const queryResult = useQuery(
		[
			"unknownMidData",
			paidMonth,
			paidYear,
			page,
			isRefreshDataCleanse,
			filters,
			sortBy,
		],
		fetchUnknownMidList,
		{
			keepPreviousData: true,
			staleTime: 5000,
			retry: false,
		},
	);

	return queryResult;
};

export default useUnknownMidListQuery;
